import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { CalendarEventAction, CalendarEventTimesChangedEvent } from 'angular-calendar';
@Component({
  selector: 'app-booking-form',
  templateUrl: './booking-form.component.html',
  styleUrls: ['./booking-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    let date = new Date().setDate(12);
    this.events.push({ title: 'asdasd', start: new Date() });
    this.events.push({ title: 'asdasasdd', start: new Date() });
    this.events.push({ title: 'svfvw', start: new Date(date) });
    this.events.push({ title: 'svfdddvw',start: new Date(date) });
  }

  view: string = 'month';

  viewDate: Date = new Date();

  events: CalendarEvent[] = [
   
  ];

  viewDateChange: EventEmitter<Date> = new EventEmitter();
}
